"use client";
import useTranslate from "@app/_hooks/useTranslate";
import { formatPrice } from "@/utils/priceUtils";
import { Heading, Paragraph } from "@app/_components/ui";
import { useMarket, useSiteInfo } from "@app/_context";
import { InfoIcon } from "lucide-react";
import type { ComponentProps } from "react";
import { useCheckout, useCheckoutContext } from "./Checkout.hooks";
import CheckoutMessage from "./CheckoutMessage";

export default function CheckoutMinimumOrderMessage(
  props: ComponentProps<typeof CheckoutMessage>,
) {
  const t = useTranslate();
  const marketConfig = useMarket().state.market;
  const { data: checkout } = useCheckout();
  const { minimumOrderValue } = useSiteInfo();
  useCheckoutContext();

  const minOrderValueThreshold =
    minimumOrderValue ?? marketConfig.minimumOrderValue ?? 0;

  const minOrderValueThresholdFormatted = formatPrice(
    minOrderValueThreshold,
    marketConfig.locale,
  );

  if (
    typeof checkout?.totalGrossAmount !== "number" ||
    !t("checkoutMinimumOrderMessageText", { strict: true }) ||
    checkout.purchasableBelowMinimumOrderValue ||
    checkout.totalGrossAmount - checkout.totalFreightInclVat >=
      minOrderValueThreshold
  ) {
    return null;
  }

  return (
    <div className="p-4">
      <CheckoutMessage
        type="warning"
        icon={<InfoIcon size={18} className="shrink-0 translate-y-0.5" />}
        {...props}
      >
        <Heading>{t("checkoutMinimumOrderMessageTitle")}</Heading>
        <Paragraph size="small">
          {minOrderValueThresholdFormatted &&
            t("checkoutMinimumOrderMessageText", {
              value: minOrderValueThresholdFormatted,
            })}
        </Paragraph>
      </CheckoutMessage>
    </div>
  );
}
